<!-- Notifications toggle -->
<button mat-icon-button (click)="openPanel()" #notificationsOrigin>
    <ng-container *ngIf="unreadCount > 0">
        <span
            class="absolute top-0 right-0 left-0 flex items-center justify-center h-3"
        >
            <span
                class="flex items-center bg-primary text-white justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full text-on-primary text-xs font-medium"
            >
                {{ unreadCount }}
            </span>
        </span>
    </ng-container>
    <mat-icon [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>
    <div
        class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-auto sm:w-auto sm:rounded-2xl overflow-hidden shadow-lg"
    >
        <!-- Header -->
        <div
            [@expandCollapse]="'expanded'"
            class="flex shrink-0 items-center bg-primary py-4 pr-4 pl-6 text-on-primary"
        >
            <svg
                class="icon-size-7 mr-4"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19.8069 5.68699C20.1049 5.93199 20.3529 6.23699 20.5339 6.58399C20.5602 6.63724 20.5653 6.69839 20.5485 6.75529C20.5316 6.81218 20.4939 6.86063 20.4429 6.89099L14.1769 10.771C13.5175 11.1793 12.7588 11.3993 11.9832 11.4073C11.2076 11.4152 10.4446 11.2107 9.77694 10.816L3.46994 7.08799C3.42023 7.05989 3.38239 7.0147 3.36345 6.96082C3.34451 6.90695 3.34575 6.84803 3.36694 6.79499C3.54804 6.36534 3.83041 5.98587 4.18994 5.68899V5.68599L4.20194 5.67899C4.46822 5.46202 4.77092 5.29408 5.09594 5.18299L9.20594 2.89899C10.0602 2.42442 11.0212 2.17537 11.9984 2.17537C12.9756 2.17537 13.9367 2.42442 14.7909 2.89899L18.8959 5.17899C19.2299 5.29299 19.5369 5.46499 19.8039 5.68399L19.8069 5.68699Z"
                />
                <path
                    d="M2.98899 8.95399C2.9934 8.9127 3.00812 8.87317 3.03178 8.83904C3.05545 8.80491 3.08731 8.77728 3.12443 8.75866C3.16156 8.74005 3.20277 8.73106 3.24427 8.73251C3.28578 8.73397 3.32626 8.74583 3.36199 8.76699L9.01499 12.107C9.91812 12.6406 10.95 12.917 11.999 12.9063C13.0479 12.8955 14.074 12.598 14.966 12.046L20.611 8.55099C20.6465 8.52898 20.6871 8.51631 20.7288 8.51417C20.7706 8.51202 20.8122 8.52047 20.8499 8.53874C20.8875 8.557 20.9199 8.58447 20.944 8.61861C20.9682 8.65275 20.9833 8.69244 20.988 8.73399C21.2684 11.3235 21.2143 13.9383 20.827 16.514C20.7304 17.1552 20.4208 17.7453 19.9481 18.1892C19.4754 18.633 18.867 18.9049 18.221 18.961L16.711 19.092C13.5762 19.3645 10.4237 19.3645 7.28899 19.092L5.77899 18.961C5.13281 18.9049 4.52435 18.6328 4.0516 18.1888C3.57886 17.7447 3.26937 17.1544 3.17299 16.513C2.79682 14.0108 2.73501 11.4715 2.98899 8.95399Z"
                />
            </svg>
            <div class="font-medium leading-10 text-white">Alertas</div>
            <div class="ml-auto flex items-center gap-2">
                <button
                    mat-button
                    class="flex items-center gap-2 text-xs text-white opacity-80 hover:opacity-100 ml-2"
                    matTooltip="Marcar todas como leidas"
                    [disabled]="unreadCount === 0"
                    (click)="markAllAsRead()">
                    <mat-icon class="icon-size-4 text-white">done_all</mat-icon>
                    Marcar todas
                </button>
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon class="text-white">close</mat-icon>
                </button>
            </div>
            <!-- <mat-slide-toggle class="ml-auto">
                <span class="text-xs">Mostrar solo las no leídas</span>
            </mat-slide-toggle> -->
        </div>

        <!-- Content -->
        <div class="relative flex flex-col flex-auto overflow-y-auto bg-card p-4 gap-3">
            <div
                *ngIf="isMarking"
                class="absolute inset-0 z-10 flex items-center justify-center bg-white/80 backdrop-blur-sm"
            >
                <bauen-spinner [message]="markingMessage" class="w-full h-full"></bauen-spinner>
            </div>
            <!-- Notifications -->
            <ng-container *ngFor="let notification of notifications; trackBy: trackByFn">
                <div class="group flex items-start gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition hover:shadow-md">
                    <!-- Notification with a link -->
                    <ng-container *ngIf="notification.link; else notificationNoLink">
                        <!-- Normal links -->
                        <ng-container *ngIf="!notification.useRouter">
                            <a
                                class="flex flex-1 items-start gap-4 min-w-0"
                                [href]="notification.link">
                                <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                            </a>
                        </ng-container>
                        <!-- Router links -->
                        <ng-container *ngIf="notification.useRouter">
                            <a
                                class="flex flex-1 items-start gap-4 min-w-0"
                                [routerLink]="notification.link">
                                <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                            </a>
                        </ng-container>
                    </ng-container>

                    <!-- Notification without a link -->
                    <ng-template #notificationNoLink>
                        <div class="flex flex-1 items-start gap-4 min-w-0">
                            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                        </div>
                    </ng-template>

                    <!-- Mark as read -->
                    <button
                        mat-icon-button
                        class="h-6 w-6 min-h-6 mt-1"
                        matTooltip="Marcar como leida"
                        (click)="markAsRead(notification)">
                        <span class="h-2 w-2 rounded-full bg-primary"></span>
                    </button>
                </div>

                <!-- Notification content template -->
                <ng-template #notificationContent>
                    <!-- Icon -->
                    <ng-container *ngIf="!notification.image">
                        <div class="flex shrink-0 items-center justify-center w-12 h-12 rounded-xl bg-primary text-on-primary shadow-sm">
                            <mat-icon
                                class="icon-size-6 text-white"
                                [svgIcon]="notification.icon || 'heroicons_outline:bell'">
                            </mat-icon>
                        </div>
                    </ng-container>
                    <!-- Image -->
                    <ng-container *ngIf="notification.image">
                        <img
                            class="shrink-0 w-12 h-12 rounded-xl overflow-hidden object-cover object-center"
                            [src]="notification.image"
                            [alt]="'Notification image'">
                    </ng-container>
                    <!-- Title, description & time -->
                    <div class="flex flex-col flex-auto min-w-0">
                        <div class="flex items-start justify-between gap-3">
                            <div
                                class="text-base font-semibold text-slate-900 leading-snug line-clamp-2"
                                [matTooltip]="notification.title || notification.tipo_descripcion || 'Alerta generica'">
                                {{ notification.title || notification.tipo_descripcion || 'Alerta generica' }}
                            </div>
                            <div class="flex items-center gap-2 text-xs text-secondary whitespace-nowrap">
                                <span *ngIf="notification.time">{{ notification.time | date:'dd MMM yyyy, h:mm a' }}</span>
                            </div>
                        </div>
                        <ng-container *ngIf="notification.description">
                            <div
                                class="mt-1 text-sm text-slate-700 line-clamp-2"
                                [innerHTML]="notification.description"></div>
                        </ng-container>
                    </div>
                </ng-template>
            </ng-container>

            <!-- No notifications -->
            <ng-container *ngIf="!notifications || !notifications.length">
                <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
                    <div class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100 dark:bg-primary-600">
                        <mat-icon
                            class="text-primary-700 dark:text-primary-50"
                            [svgIcon]="'heroicons_outline:bell'"></mat-icon>
                    </div>
                    <div class="mt-5 text-2xl font-semibold tracking-tight">No tienes alertas</div>
                    <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">Cuando tengas alertas se mostraran aqui.</div>
                </div>
            </ng-container>

        </div>

    </div>

</ng-template>
